module.exports = __webpack_public_path__ + "img/no-search-result.bf57610a.png";